import Icon from '../components/Icon.vue'

Icon.register({
  tooth: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M444 96.3C433 51 396.9 14.2 352 2.5 319.8-5.8 289 7.6 262.8 26.9 259.6 29.3 255.9 30.6 252.3 32.3L280.7 50.6C288.1 55.3 290.2 65.2 285.5 72.7 281 79.6 271.2 82.5 263.3 77.5L162.8 12.8C142.1 2 119.5-3.6 96 2.5 51.1 14.2 15 51 4 96.3-6.1 137.9 3.6 177.1 25.5 206.7 48.9 238.3 58.2 275.3 61.8 314 66.2 361.2 72.1 408.2 82.7 454.4L90.5 488.3C93.7 502.2 106 512 120.2 512 134.2 512 146.4 502.4 149.8 488.8L184.2 350.4C188.8 332.1 205.2 319.3 224 319.3S259.2 332.1 263.7 350.4L298.2 488.8C301.6 502.4 313.8 512 327.8 512 341.9 512 354.2 502.2 357.4 488.3L365.2 454.4C375.8 408.2 381.8 361.2 386.2 314 389.8 275.3 399.1 238.3 422.5 206.7 444.4 177.1 454.1 137.9 444 96.3z'
      }
    ]
  }
})
